function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IframeWrapper from '../iframe-wrapper/IframeWrapper';
export const MAPS_URL = 'https://www.google.com/maps/embed/v1';
export let MapsType = /*#__PURE__*/function (MapsType) {
  MapsType["PLACE"] = "place";
  MapsType["STREETVIEW"] = "streetview";
  return MapsType;
}({});
function createSrc(apiKey, type, params) {
  const encoded = encodeURIComponent(params);
  return type === MapsType.PLACE ? `${MAPS_URL}/place?key=${apiKey}&q=${encoded}` : `${MAPS_URL}/streetview?key=${apiKey}&location=${params}`;
}
export const Maps = _ref => {
  let {
    title = 'Mappa',
    apiKey,
    type = MapsType.PLACE,
    params,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(IframeWrapper, _extends({}, rest, {
    title: title,
    src: createSrc(apiKey, type, params),
    "data-ref": `${type}-iframe`
  }));
};
export default Maps;
//# sourceMappingURL=Maps.js.map